import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'

import { nullablePropType } from '../../../common/propTypes'

const ALLOWED_DECIMAL_SEPARATORS = ['.', ',']

/**
  NOTE: warning 'React does not recognize the `inputRef` prop on a DOM element'
  is apparently solved on MaterialUI V5 (more info in
  https://github.com/mui-org/material-ui/issues/22253
  and https://github.com/mui-org/material-ui/pull/23174)
 */
const FormatNumberField = ({ ref, onChange, name, value, ...other }) => {
  return (
    <NumberFormat
      getInputRef={ref}
      name={name}
      onValueChange={values => {
        const numberValue = values.value ? Number(values.value) : NaN

        onChange({
          target: {
            name,
            value: !isNaN(numberValue) ? numberValue : null,
          },
        })
      }}
      value={value ?? ''}
      allowedDecimalSeparators={ALLOWED_DECIMAL_SEPARATORS}
      {...other}
    />
  )
}

FormatNumberField.propTypes = {
  ref: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: nullablePropType(PropTypes.number.isRequired),
}

export default FormatNumberField
